import React, { useState } from "react";
import { Share2, Check } from "lucide-react";
import { toast } from "sonner";

export default function ShareApp({ className = "", showCount = false, showMilestone = false }) {
  const [copied, setCopied] = useState(false);
  const [count, setCount] = useState(() => parseInt(localStorage.getItem("shareCount") || "0", 10));

  const MILESTONES = [5, 10, 25, 50];
  const next = MILESTONES.find((m) => m > count) || null;
  const prev = [...MILESTONES].reverse().find((m) => m <= count) || 0;
  const pct = next ? Math.round(((count - prev) / (next - prev)) * 100) : 100;

  const bump = () => {
    const n = parseInt(localStorage.getItem("shareCount") || "0", 10) + 1;
    localStorage.setItem("shareCount", String(n));
    setCount(n);
    if ([5, 10, 25, 50].includes(n)) {
      toast.success(`🎉 ${n} friends invited! Thank you for spreading the good news.`, { duration: 5000 });
    }
  };

  const share = async () => {
    const url = window.location.origin;
    const data = { title: "In His Image Radio", text: "Listen to gospel, praise & worship on In His Image Radio 🙌", url };
    if (navigator.share) {
      try { await navigator.share(data); bump(); return; } catch (e) { if (e.name === "AbortError") return; }
    }
    try {
      await navigator.clipboard.writeText(`${data.text} ${url}`);
      setCopied(true); bump();
      toast.success("Link copied — share the good news!");
      setTimeout(() => setCopied(false), 2000);
    } catch (e) { toast.error("Could not share"); }
  };

  return (
    <div>
      <button onClick={share} data-testid="share-app-btn" className={className || "w-full flex items-center justify-center gap-2 px-4 py-2.5 rounded-xl bg-white/5 hover:bg-white/10 text-sm font-semibold transition-colors"}>
        {copied ? <><Check className="w-4 h-4 text-emerald-400" /> Copied</> : <><Share2 className="w-4 h-4" /> Share the app</>}
      </button>
      {showCount && count > 0 && (
        <p className="text-[11px] text-center text-[#E6B34A] mt-1.5" data-testid="share-count">You've shared with {count} friend{count === 1 ? "" : "s"} 🙌</p>
      )}
      {showMilestone && (
        <div className="mt-3" data-testid="invite-milestone">
          <div className="flex items-center justify-between text-[11px] mb-1.5">
            <span className="text-zinc-400">{count} invited</span>
            <span className="text-[#E6B34A] font-semibold">{next ? `${next - count} to next milestone 🎉` : "Top inviter — thank you! 🙌"}</span>
          </div>
          <div className="h-2 rounded-full bg-white/10 overflow-hidden">
            <div className="h-full bg-[#E6B34A] transition-all duration-500" style={{ width: `${pct}%` }} />
          </div>
        </div>
      )}
    </div>
  );
}
